module.exports = __webpack_public_path__ + "static/media/26.d2001a9b.png";